import { Carousel } from 'react-bootstrap'
import { AdvertType, CarouselImage } from 'types/baseTypes'
import { StyledPromotion, StyledSearch } from './SlideShow.styled'

interface CarouselCaptionProps {
  item: CarouselImage
  index: number
  clickHandler: (e: MouseEvent, item: CarouselImage, index: number) => void
}

export const SlideShowPromotion = ({ item, index, clickHandler }: CarouselCaptionProps) => {
  return (
    <Carousel.Caption
      style={item.AdvertType !== AdvertType.NonPromotional ? { marginTop: '-3rem', paddingBottom: '0' } : null}
    >
      {item.AdvertType !== AdvertType.NonPromotional && (
        <StyledPromotion style={{ paddingTop: '-1rem' }}>
          <span>{item.AdvertType === AdvertType.Promotional ? item.Promotion : item.Description}</span>
          <StyledSearch onClick={(e) => clickHandler(e, item, index)}>
            {item.AdvertType === AdvertType.Promotional ? 'Click Here' : 'Learn More'}
          </StyledSearch>
        </StyledPromotion>
      )}
    </Carousel.Caption>
  )
}
